module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "buttonStyle": "primary",
      "heading": _vm.permitLabel + ' Application',
      "size": "default",
      "showText": _vm.showText,
      "buttonText": _vm.permitLabel,
      "buttonSize": _vm.size,
      "buttonIcon": "fa fa-file-alt",
      "disableButton": !_vm.isManager('admin|finance|management|property')
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('progress-workflow', {
    ref: "Progress",
    attrs: {
      "row-data": _vm.rowData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd80b69"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/ProgressWorkflowAction.vue
// module id = 1354
// module chunks = 0